<div [ngSwitch]="type">
	<div *ngSwitchCase="'proveedores'">
		<div class="alert"><i class="fas fa-exclamation-triangle"></i> No se han agregado proveedores</div>
	</div>
	<div *ngSwitchDefault>
		<div class="alert"><i class="fas fa-exclamation-triangle"></i> No hay información para mostrar</div>
	</div>
</div>